import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AppConfigService {

    private appConfig: any;
    tempEventId: any;
    loginData: any;
    eventId = null;
    inviteApiConfig: any;

    constructor(
        private http: HttpClient
    ) { }


    /**
     * Loads the main app config file into memory.
     * @returns Observable http response.
     */
    async loadAppConfig() {
        let configURI = environment.production ? '/assets/config/app.config.prod.json' : '/assets/config/app.config.dev.json';
        if (!configURI || configURI === '') {
            configURI = '/assets/config/app.config.dev.json';
        }
        return this.http.get(configURI)
            .toPromise()
            .then(data => {
                this.appConfig = data;
            });
    }

    /**
     * Returns the app config file details.
     * @param baseKey - This is the base key to use to narrow down in the json object.
     * @param key - this is the nested key within the base key object in the file
     * @returns endpoint string or entire app config object
     */
    getConfig(baseKey: string = 'server', key: string = 'api_endpoint') {
        return this.appConfig[baseKey][key];
    }

    /**
     * Finds and returns the value for provided key in localstorage.
     * @param key - the key to use for lookup
     */
    getLocalConfig(key: string) {
        return localStorage.getItem(key);
    }

    setLocalConfig(key, value) {
        localStorage.setItem(key, value);
    }

    removeLocalConfig(key) {
        localStorage.removeItem(key);
    }

    clearStorage() {
        this.eventId = null;
        localStorage.clear();
        sessionStorage.clear();
    }

}
